import React, { useEffect, useState } from "react";
import ButtonArrow from "../components/ButtonArrow";
import CarouselComponent from "../components/CarouselComponent";
import axios from "axios";
import { axiosConfig } from "../Helpers/AxiosRequest";
import { API_URL } from "../Helpers/api";
import { Helmet } from "react-helmet";
import galleryImg from "../Images/gallery.png";
import shuffleArray from "../Helpers/ShuffleArray";
import { useModal } from "../Contexts/ModalContext";
import GalleryCarousel from "../components/GalleryCarousel";

const Gallery = () => {
  const [gallery, setGallery] = useState([]);
  const [activeImage, setActiveImage] = useState(undefined);
  const { isOpen, openModal } = useModal();

  useEffect(() => {
    axios(axiosConfig("GET", `${API_URL}/images/get-gallery`))
      .then(({ data }) => {
        if (data.success) {
          const shuffledImg = shuffleArray(data.images);
          setGallery(shuffledImg);
        }
      })
      .catch((err) => console.error(err.message));
  }, []);

  useEffect(() => {
    if (!isOpen && activeImage != null) {
      setActiveImage(undefined);
    }
  }, [isOpen, activeImage]);

  useEffect(() => {
    if (activeImage != null) {
      openModal(
        <GalleryCarousel gallery={gallery} activeImage={activeImage} setActiveImage={setActiveImage} />,
        "",
        "fullscreen",
      );
    }
  }, [activeImage]);

  return (
    <main className="z-2 postiion-relative">
      <Helmet>
        <title>Galería Bella Unión – Fotos y Paisajes de la Región</title>
        <meta
          name="description"
          content="Explora la galería de imágenes de Bella Unión: paisajes, actividades y momentos únicos que reflejan la esencia de nuestra región."
        />
        <meta
          name="keywords"
          content="galería Bella Unión, fotos Bella Unión, imágenes turismo Uruguay, paisajes Bella Unión, actividades Bella Unión"
        />
        <link rel="canonical" href="https://bellaunion.uy/galeria" />
        <meta property="og:title" content="Galería Bella Unión – Fotos y Paisajes de la Región" />
        <meta
          property="og:description"
          content="Explora la galería de imágenes de Bella Unión: paisajes, actividades y momentos únicos que reflejan la esencia de nuestra región."
        />
        <meta property="og:url" content="https://bellaunion.uy/galeria" />
        <meta property="og:type" content="website" />
        <meta property="og:image" content={galleryImg} />

        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Galería Bella Unión – Fotos y Paisajes de la Región" />
        <meta
          name="twitter:description"
          content="Explora la galería de imágenes de Bella Unión: paisajes, actividades y momentos únicos que reflejan la esencia de nuestra región."
        />
        <meta name="twitter:image" content={galleryImg} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <CarouselComponent />
      <div
        className="position-absolute top-0 w-100 d-flex flex-column z-3 filter-dark"
        style={{ height: "100vh" }}
      >
        <h1 className="text-center text-light mt-auto">Galería</h1>
        <div className="mb-auto text-center mt-5">
          <ButtonArrow />
        </div>
      </div>
      <div className="bg-light" id="main-container" style={{ marginTop: "100vh" }}>
        {/* <h2 className="text-center my-5">Galería</h2> */}
        <div className="container-fluid bg-dark pt-4">
          <div className="row g-3">
            {gallery.map((image, i) => (
              <div className="col-xxl-2 col-lg-3 col-md-4 col-6" key={image._id}>
                <div
                  className="gallery-img rounded"
                  onClick={() => setActiveImage(i)}
                  style={{ backgroundImage: `url(${image.url})`, aspectRatio: "4 / 5" }}
                ></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </main>
  );
};

export default Gallery;
